import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

function LandingPage() {
  return (
    <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>

      {/* Background Video */}
      <Box
        component="video"
        autoPlay
        muted
        loop
        playsInline
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          minWidth: '100%',
          minHeight: '100%',
          transform: 'translate(-50%, -50%)',
          objectFit: 'cover',
          zIndex: -2,
        }}
      >
        <source src="https://res.cloudinary.com/dspkr9fux/video/upload/v1750413426/sxszswy2u5qfgrjscmnq.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </Box>

      {/* Dark Overlay for Contrast */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          bgcolor: 'rgba(0, 0, 0, 0.4)',
          zIndex: -1,
        }}
      />

      {/* Message + CTA */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          color: 'white',
          pt: '28vh',
          px: 3,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '1.2rem', md: '1.7rem' },
            fontWeight: 1000,
            fontFamily: 'General Sans, sans-serif',
            textAlign: 'center',
            maxWidth: '10000px',
            mx: 'auto',
            px: 3,
            lineHeight: 1.6,
            color: ' #fffdfa ',
            letterSpacing: '0.05em',
          }}
        >
          Discover the top 10 real estate projects that align with your goals.
          <br />
          We analyze your preferences to deliver a personalized, high-quality shortlist
          <br />
          - saving you time and helping you make confident decisions.
        </Typography>

        <Button
          component={Link}
          to="/projects"
          variant="contained"
          sx={{
            mt: 4,
            fontSize: '1.5rem',
            FontFamily: 'General Sans, sans-serif',
            px: 4,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 500,
            backgroundColor: '#77996b',
            color: '#ffffff', // text color
            '&:hover': {
              backgroundColor: '#5f7f56', // darker on hover
            },
          }}
        >
          Get Started
        </Button>

      </Box>
    </Box>
  );
}

export default LandingPage;
